import { StoreState, VoidCallback } from '@deqo/foundation';
import React, { useCallback } from 'react';
import { LFC } from '../../../Legacy';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Icon, NoIcon } from '../../../concepts/resources/Icon';
import { useResolve } from '../../Container';
import { isItEaster } from '../../occasions/xmas/WithEaster';
import { userRemoveHat, userWearHat } from '../../packages/hats/HatsCommands';
import { herdToMe } from '../../packages/herding/HerdingCommands';
import { follow } from '../../packages/presentation/PresentCommands';
import { spotlightUser } from '../../packages/spotlight/SpotlightCommands';
import { useEditorSessionObserver } from '../EditorSession';
import { MyRoleInfo } from '../MyRoleInfo';
import { Participant } from '../participants/Participant';
import { IsElevated } from '../workflow/IsElevated';
import { Menu } from './../../../ui';

export const ParticipantActionMenu: LFC<{ participant: StoreState<Participant>, onAction: VoidCallback }> = ({ participant, onAction }) => {

    const dispatch = useResolve(CommandDispatcher);
    const { canManage } = useEditorSessionObserver(MyRoleInfo);
    const isHost = useEditorSessionObserver(IsElevated);

    const onFollow = useCallback(() => {
        dispatch(follow, [participant.id]);
        onAction();
    }, [participant, onAction]);

    const onHerd = useCallback(() => {
        dispatch(herdToMe);
        onAction();
    }, [participant, onAction]);

    const onSpotlight = useCallback(() => {
        dispatch(spotlightUser, [participant.id]);
        onAction();
    }, [participant, onAction]);

    const onWearHat = useCallback(() => {
        dispatch(userWearHat);
        onAction();
    }, [participant, onAction]);

    const onWearEasterHat = useCallback(() => {
        dispatch(userWearHat, ['BunnyEars']);
        onAction();
    }, [participant, onAction]);

    const onRemoveHat = useCallback(() => {
        dispatch(userRemoveHat);
        onAction();
    }, [participant, onAction]);

    return <Menu>
        <Menu.Section first title={participant.name}>
            {participant.self &&
                <Menu.Item data-action="editor.participants.everyoneToMe" onClick={onHerd} disabled={!canManage || !isHost}>
                    <Icon size="1.2" src="deqo://icons/i8/herd" />
                    <Menu.ItemText>Everyone To Me</Menu.ItemText>
                    <Menu.Shortcut keys="SHIFT+B" />
                </Menu.Item>
            }
            {!participant.self && <Menu.Item data-action="editor.participants.follow" disabled={participant.presence === 'offline'} onClick={onFollow}>
                <Icon size="1.2" src="deqo://icons/hero/eye" />
                <Menu.ItemText>Follow</Menu.ItemText>
            </Menu.Item>}
            <Menu.Item data-action={`editor.participants.${participant.self ? 'self' : 'other'}.spotlight`} onClick={onSpotlight}>
                <Icon size="1.2" src="deqo://icons/i8/searchlight2" />
                <Menu.ItemText>Spotlight</Menu.ItemText>
            </Menu.Item>
        </Menu.Section>
        {participant.self &&
            <Menu.Section>
                {/* <Menu.SubMenuItem placement="left-start" inner={{ direction: 'left', offset: '.5' }} content={<HatWidget />}>

                    <Icon size="1.2" src="deqo://icons/i8/hat" />
                    <Menu.ItemText>Wear Hat</Menu.ItemText>
                    <Menu.Shortcut keys="SHIFT+H" />
                </Menu.SubMenuItem> */}
                <Menu.Item data-action="editor.participants.wearHat" onClick={onWearHat}>
                    <Icon size="1.2" src="deqo://icons/i8/hat" />
                    <Menu.ItemText>Wear Hat</Menu.ItemText>
                    <Menu.Shortcut keys="SHIFT+H" />
                </Menu.Item>
                {isItEaster() && <>
                    <Menu.Item data-action="editor.participants.wearEasterHat" onClick={onWearEasterHat}>
                        <NoIcon size="1.2" />
                        <Menu.ItemText>Wear Bunny Ears</Menu.ItemText>
                    </Menu.Item>
                </>}
                <Menu.Item data-action="editor.participants.removeHat" disabled={!participant.hat} onClick={onRemoveHat}>
                    <NoIcon size="1.2" />
                    <Menu.ItemText>Remove Hat</Menu.ItemText>
                </Menu.Item>
            </Menu.Section>}
    </Menu>;
};
